import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=f6e9591c&scoped=true"
import script from "./UpgradeCard.vue?vue&type=script&lang=js"
export * from "./UpgradeCard.vue?vue&type=script&lang=js"
import style0 from "./UpgradeCard.vue?vue&type=style&index=0&id=f6e9591c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e9591c",
  null
  
)

export default component.exports